import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Select, SIZE } from 'baseui/select';
import useShortcut from '../../image/labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../image/labelling/providers/utils/shortcut';
import type { AnnotationLabelT } from '../types/types';
type PropsT = {
  annotationLabels: AnnotationLabelT[];
  checkLabelMaxReached: (annotationLabel: AnnotationLabelT) => boolean;
  onChange: (annotationLabel: AnnotationLabelT) => void;
  readOnly: boolean;
  selectedLabel: AnnotationLabelT;
  allowedAnnotationLabels?: AnnotationLabelT[];
};
const AnnotationLabelSelector = ({
  annotationLabels,
  checkLabelMaxReached,
  onChange,
  readOnly,
  selectedLabel,
  allowedAnnotationLabels
}: PropsT) => {
  /**
   * need to clone annotationLabels because it is writable array
   * but options in Select expects an read-only array.
   */
  const annotationLabelOptions = useMemo(() => (allowedAnnotationLabels === undefined ? annotationLabels : allowedAnnotationLabels).map(annotationLabel => ({
    ...annotationLabel
  })), [allowedAnnotationLabels, annotationLabels]);
  const {
    registerHotKeys
  } = useShortcut();
  const annotationLabelSelectorRef = useRef<HTMLInputElement | null>(null);
  const handleFocusAnnotationLabelSelector = useCallback(() => {
    annotationLabelSelectorRef?.current?.click();
  }, []);
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['f'],
      onAction: handleFocusAnnotationLabelSelector
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [registerHotKeys, handleFocusAnnotationLabelSelector]);
  return <Select inputRef={annotationLabelSelectorRef} clearable={false} options={annotationLabelOptions} placeholder="" labelKey="title" valueKey="title" size={SIZE.mini} value={[{
    ...selectedLabel
  }]} disabled={readOnly} overrides={{
    ControlContainer: {
      props: {
        'data-e2e-id': 'edit-annotation-label'
      }
    }
  }} onChange={params => {
    // @ts-expect-error todo(ts-migration) TS2322 Type 'AnnotationLabelT | undefined' is not assignable to type 'AnnotationLabelT'.
    const annotationLabel: AnnotationLabelT = annotationLabels.filter(annotation => {
      return annotation.title === params.value[0]?.title;
    })[0];
    if (!checkLabelMaxReached(annotationLabel)) {
      onChange(annotationLabel);
    }
  }} />;
};
export default AnnotationLabelSelector;